import React from "react"

export const AccountContext = React.createContext({})

export function withAccount(Component) {
  const displayName = `withAccount(${Component.displayName || Component.name})`

  const C = (props) => {
    const { wrappedComponentRef, ...remainingProps } = props

    return (
      <AccountContext.Consumer>
        {(account) => {
          return <Component {...remainingProps} account={account} ref={wrappedComponentRef} />
        }}
      </AccountContext.Consumer>
    )
  }

  C.displayName = displayName
  C.WrappedComponent = Component

  return React.memo(C)
}
